import HomeScheduleBarRoot, { Props } from './HomeScheduleBar'

export default function HomeScheduleBar(props: Props) {
  return <HomeScheduleBarRoot {...props} />
}
